import { ApolloClient } from '@apollo/client/core'
import gql from 'graphql-tag'
import { VersionStatus } from '@/generated/graphql'

const nameFragments = {
  Product: gql`
    fragment BreadcrumbCachedProductName on Product {
      name
    }
  `,
  ProductConfiguration: gql`
    fragment BreadcrumbCachedConfigName on ProductConfiguration {
      name
    }
  `,
  Site: gql`
    fragment BreadcrumbCachedSiteName on Site {
      name
    }
  `,
  Module: gql`
    fragment BreadcrumbCachedModuleName on Module {
      name
    }
  `,
  Ebom: gql`
    fragment BreadcrumbCachedEbomName on Ebom {
      name
    }
  `,
}

export function cachedEntityName(
  client: ApolloClient<unknown>,
  typename: keyof typeof nameFragments,
  id: string | undefined,
): string | undefined {
  if (!id) {
    return undefined
  }
  return client.readFragment<{ name?: string }>({
    id: `${typename}:${id}`,
    fragment: nameFragments[typename],
  })?.name
}

const bopVersionFragment = gql`
  fragment BreadcrumbCachedBopVersion on BOP {
    version
    versionStatus
  }
`

export function cachedBopVersion(
  client: ApolloClient<unknown>,
  id: string | undefined,
): { version: number; versionStatus: VersionStatus } | undefined {
  if (!id) {
    return undefined
  }
  return (
    client.readFragment<{ version: number; versionStatus: VersionStatus }>({
      id: `BOP:${id}`,
      fragment: bopVersionFragment,
    }) ?? undefined
  )
}
